export default {"src":"/_next/static/media/phone.7926170a.svg","height":19,"width":12,"blurWidth":0,"blurHeight":0};